import type { AiConversationItem } from '../transports/ai-transport';
import type { MeetingSummaryResult } from '../../models/nova-voice.model';

/**
 * Pure shape-peelers over a Foundry conversation item list. Transcript,
 * analysis, and follow-up turns all live as items inside the conversation;
 * these extract a specific turn BY SHAPE (order-independent), so they work the
 * same on a live listItems() result or the disk cache. Shared by the
 * summary features and the get_meeting_* tools to avoid divergent copies.
 */

/** Meeting analysis turn → MeetingSummaryResult, or null. */
export function peelMeetingAnalysis(items: AiConversationItem[]): MeetingSummaryResult | null {
  for (const item of items) {
    if (item.role === 'user' || !item.text) continue;
    try {
      const parsed = JSON.parse(item.text);
      if (parsed && typeof parsed.summary_title === 'string' && parsed.summary_title.length > 0) {
        return parsed as MeetingSummaryResult;
      }
    } catch { /* not the analysis turn */ }
  }
  return null;
}

/** Meeting transcript turn ({"transcript":"…"}) → string, or null. */
export function peelTranscript(items: AiConversationItem[]): string | null {
  for (const item of items) {
    if (item.role !== 'user' || !item.text) continue;
    try {
      const parsed = JSON.parse(item.text);
      if (parsed && typeof parsed.transcript === 'string' && parsed.transcript.trim()) {
        return parsed.transcript;
      }
    } catch { /* not the transcript turn */ }
  }
  return null;
}
